import type { TUseLoginResponse } from '@features/auth/lib/types';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import type { AxiosResponse } from 'axios';

import { axiosInstance } from '@shared/lib/axios';
import type { TAxiosError } from '@shared';
import { MUTATIONS_INFO } from '@shared';

type TUseLoginRequestPayload = {
  email: string;
  password: string;
  token?: string;
  rememberMe: boolean;
};

export type TUseLoginPayload = TUseLoginRequestPayload;

export type TUseLoginParams = {
  options: UseMutationOptions<AxiosResponse<TUseLoginResponse>, unknown, TUseLoginPayload>;
};

export const useLogin = ({ options }: TUseLoginParams) =>
  useMutation<AxiosResponse<TUseLoginResponse>, TAxiosError, TUseLoginRequestPayload>((params) => {
    const body = {} as TUseLoginPayload;

    return axiosInstance.post<TUseLoginResponse, AxiosResponse<TUseLoginResponse>, TUseLoginRequestPayload>(
      MUTATIONS_INFO.login,
      { ...body, ...params },
    );
  }, options);
